import { createAction } from '@reduxjs/toolkit';
import { SmoMoonList } from '../../../../Models/Smo/SmoMoonList';
import { User } from '../../../../Models/User/User';
import { UserRun } from '../../../../Models/User/UserRun';
import { UserSettings } from '../../../../Models/User/UserSettings';
import { UserWidgetSettings } from '../../../../Models/User/UserWidgetSettings';
import { Optional } from '../../../../Utils/Types';

const getCurrentUserMoonLists = createAction('GET_CURRENT_USER_MOON_LISTS');
const setCurrentUser = createAction<User>('SET_CURRENT_USER');
const updateCurrentUserSettings = createAction<Partial<UserSettings>>('UPDATE_USER_SETTINGS');
const updateCurrentUserWidgetSettings = createAction<Partial<UserWidgetSettings>>('UPDATE_USER_WIDGET_SETTINGS');
const resetCurrentUserWidgetSettings = createAction('RESET_USER_WIDGET_SETTINGS');
const setCurrentUserSettings = createAction<UserSettings>('SET_CURRENT_USER_SETTINGS');
const setCurrentUserRun = createAction<Optional<UserRun>>('SET_CURRENT_USER_RUN');
const setCurrentUserMoonLists = createAction<SmoMoonList[]>('SET_CURRENT_USER_MOON_LISTS');
const favoriteMoonListWithId = createAction<string>('FAVORITE_MOON_LIST_WITH_ID');
const addFavoriteMoonList = createAction<SmoMoonList>('ADD_FAVORITE_MOON_LIST');
const removeFavoriteMoonListWithId = createAction<string>('REMOVE_FAVORITE_MOON_LIST_WITH_ID');

export default {
  getCurrentUserMoonLists,
  setCurrentUser,
  updateCurrentUserSettings,
  updateCurrentUserWidgetSettings,
  resetCurrentUserWidgetSettings,
  setCurrentUserSettings,
  setCurrentUserRun,
  setCurrentUserMoonLists,
  favoriteMoonListWithId,
  addFavoriteMoonList,
  removeFavoriteMoonListWithId
};
